<template>
    <layout :racingstars="$page.props.racingstars" :jetstream="$page.props.jetstream" :user="$page.props.user" title="Events">
        <template #header>
            Events
        </template>

        <div class="sm:p-6">
			<div class="py-4">
	        	<tw-table :headers="headers" :items="events.data">
                    <template #footer>
						<pagination class="mt-6" :data="events" />
                    </template>
	        	</tw-table>
	        </div>
	    </div>
    </layout>
</template>

<script>
	import Layout from '@/Layouts/Layout'
	import TwTable from '@/Global/Elements/TwTable'
	import Pagination from '@/Global/Pagination'

	export default {
		props: {
			events: Object,
		},
		components: {
			Layout,
			TwTable,
			Pagination,
		},
		setup() {
			const headers = [
				{
					text: 'Name',
					value: 'name',
				},
				{
					text: 'Aggregate Version',
					value: 'aggregate_version',
				},
				{
					text: 'Event Version',
					value: 'event_version',
				},
				{
					text: 'Created At',
					value: 'created',
				},
			]

			return {
				headers,
			}
		}
	}
</script>